// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

// Types
type ContainerStyleProps = {
    buttonClearOff: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    display: block;
    margin: auto;
    box-sizing: border-box;
    background-color: ${theme.colors.white};
    width: 100%;
    max-height: auto;

    &::-webkit-scrollbar {
        width: 12px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.base[200]};
        border: 3px solid ${theme.colors.white};
        border-radius: 20px;
    }

    .header {
        position: sticky;
        position: -webkit-sticky;
        background-color: ${theme.colors.white};
        top: 0;
        z-index: 2;
        margin-bottom: 16px;
    }

    .title-button {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        font-family: Arial, sans-serif;
        font-size: 16px;
        font-weight: 600;

        line-height: 22px;
        padding: 16px 8px;
    }

    .buttonModal-title {
        display: flex;
    }

    .title {
        font-style: normal;
        font-size: 16px;
        line-height: 22px;
        border: none;
        cursor: pointer;
        background-color: transparent;
        color: ${theme.colors.base[400]};
    }

    .ocult-modal {
        display: inline;
        margin-right: 8px;

        @media (min-width: 768px) {
            display: none;
        }
    }

    .chip-wrapper {
        padding: 0 8px 8px;
    }

    .webp-chip {
        height: 24px;

        &:first-child {
            margin-right: 8px;
        }
    }

    .button-clear {
        font-size: 14px;
        font-weight: 400;

        border: none;
        cursor: pointer;
        background-color: transparent;
        color: ${theme.colors.system.danger[300]};
        line-height: 20px;
    }

    .hand-label {
        display: block;
        text-align: center;
    }

    .clapping {
        margin-bottom: 18px;
    }

    .label-not-notification {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 1rem;
        font-weight: 400;

        letter-spacing: 0;
        line-height: 1.375;
    }

    .content-slot {
        height: 80vh;
        overflow: auto;
        padding-bottom: 24px;

        &::-webkit-scrollbar {
            width: 12px;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${theme.colors.base[200]};
            border: 3px solid ${theme.colors.white};
            border-radius: 20px;
        }
    }

    @media (min-width: 768px) {
        .content-slot {
            max-height: 445px;
            height: fit-content;
        }

        width: 360px;
        min-width: 360px;
        border-radius: 8px;
        box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);

        .title {
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
        }
    }

    @media (min-width: 1366px) {
        width: 545px;

        .header {
            padding: 0 24px 24px;
        }
    }

    ${({ buttonClearOff }) =>
        buttonClearOff &&
        css`
            .button-clear {
                color: ${theme.colors.base[200]};
                cursor: not-allowed;
            }
        `}
`;

type ContentWrapperStyleProps = {
    isNewNotifications: boolean;
};

export const ContentWrapper = styled.div<ContentWrapperStyleProps>`
    justify-content: flex-start;

    ${({ isNewNotifications }) =>
        !!isNewNotifications &&
        css`
            display: none;
        `}
`;

type ContentNewWrapperStyleProps = {
    isTotalNotifications: boolean;
};

export const ContentNewWrapper = styled.div<ContentNewWrapperStyleProps>`
    justify-content: flex-start;

    &:last-child {
        border: none;
    }

    @media (min-width: 1920px) {
        .content-slot {
            max-height: 591px;
        }
    }

    ${({ isTotalNotifications }) =>
        !isTotalNotifications &&
        css`
            display: none;
        `}
`;
